module.exports = __webpack_public_path__ + "img/boshu_catch.92a52dcd.png";